import { PdfInfo } from "../Pdf/PdfInfo";

export class StatementPdfYear {
    Year: number;
    StatementPdfs: PdfInfo[];
    PostingYear: string;
    constructor(year: number, postingYear:string, statementPdfs: PdfInfo[]) {
        this.Year = year;
        this.StatementPdfs = statementPdfs;
        this.PostingYear = postingYear;
    }
}